import AddTemplateComponentCommand from "../addComponentCommandBase/addTemplateComponentCommand";

class AddTemplateQuoteTableCommand extends AddTemplateComponentCommand {
  constructor(componentData) {
    super(componentData);
    this.componentData = componentData;
  }

  redo() {
    super.redo();
    this.componentData.addDealTableTab();
  }

  execute() {
    if (this.isRedo) {
      this.redo();
    } else {
      super.execute();
    }
  }

  undo() {
    // no need to do this
    super.undo();
  }
}

export default AddTemplateQuoteTableCommand;
